import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';
import ArcGisButton from './components/button';

const ArcGisMap = ({
  attachmentId,
  imgUrl,
  imgCaption,
  mapurl,
  mapsize,
  buttontxt = '',
  buttonstyle = 'is-style-black-text',
  buttonalign = '',
  frontend = true,
}) => {
  function generateImageAnchor() {
    const img = (imgUrl) ? <img src={imgUrl} alt={buttontxt} /> : null;

    /*
     * Whether or not we have an image URL, we still need the anchor on the
     * frontend because the JavaScript used for the button finds the button by its
     * proximity to the `arcgisMap_link` element.
     */
    if (frontend) {
      return (
        <a
          target="_blank"
          className="arcgisMap_link arcgisMap_image_large"
          rel="noreferrer"
          href={mapurl}
        >
          {img}
        </a>
      );
    }

    return img;
  }

  const imageAnchor = generateImageAnchor();

  return (
    <figure
      id={`attachment_${attachmentId}`}
      className="wp-caption aligncenter"
      aria-describedby={`caption-attachment-${attachmentId}`}
      data-component="arcgisMapFrame"
    >
      {imageAnchor}
      <div
        id={`arcgisMap_overlay_${attachmentId}`}
        className={`arcgisMap_overlay ${mapsize}`}
      />
      {(attachmentId && imgCaption) ? (
        <figcaption
          id={`caption-attachment-${attachmentId}`}
          className="wp-caption-text figure__caption arcgisMap_image_large"
        >
          {imgCaption}
        </figcaption>
      ) : null}
      <ArcGisButton
        mapurl={mapurl}
        buttontxt={buttontxt}
        buttonstyle={buttonstyle}
        buttonalign={buttonalign}
        frontend={frontend}
      />
    </figure>
  );
};

ArcGisMap.propTypes = {
  attachmentId: PropTypes.number,
  imgUrl: PropTypes.string,
  imgCaption: PropTypes.string,
  mapurl: PropTypes.string,
  mapsize: PropTypes.string,
  buttontxt: PropTypes.string,
  buttonstyle: PropTypes.string,
  buttonalign: PropTypes.string,
  frontend: PropTypes.bool,
};

ArcGisMap.defaultProps = {
  attachmentId: 0,
  imgUrl: '',
  imgCaption: '',
  mapurl: '',
  mapsize: 'full',
  buttontxt: '',
  buttonstyle: '',
  buttonalign: '',
  frontend: true,
};

export default ArcGisMap;
